import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaStickyUtility from '@sparta.global.utilities/sparta-sticky-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import { learnMore, learnMoreUrl, barker, termsAndConditions, applyNow, compareProduct, rating, getProgramRulesLink } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';
import spartaLazyLoadUtility from '@sparta.global.utilities/sparta-lazy-load-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { checkbox } from '@sparta.global.helpers/checkbox-helper/dist/es6.js';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template$2 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\r\n  <div class=\"column small-12 large-centered cards-list-placeholder\"></div>\r\n</div>\r\n\r\n<div class=\"card-list\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":5,"column":33},"end":{"line":5,"column":47}}}))
    + "\"></div>\r\n<div class=\"card-content\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":6,"column":36},"end":{"line":6,"column":52}}}))
    + "\"></div>\r\n\r\n<span class=\"ada-hidden compare-card-add-remove-announcement\" aria-live=\"polite\"></span>\r\n";
},"useData":true});
const renderTemplate$2 = function (data, options) {
  return Template$2(data, options);
};

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"barker")||(depth0 && lookupProperty(depth0,"barker"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_POSITION") : stack1),(depth0 != null ? lookupProperty(depth0,"campaign") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_COLOR") : stack1),{"name":"barker","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":6,"column":30}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1)) != null ? lookupProperty(stack1,"value") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":22,"column":11}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"show-for-medium-up\">\r\n        <a id=\"ratings-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "-small\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_VALUE") : stack1), depth0))
    + "\" class=\"rating-link\"\r\n          target=\"_blank\" rel=\"noopener noreferrer\">\r\n          "
    + container.escapeExpression((lookupProperty(helpers,"rating")||(depth0 && lookupProperty(depth0,"rating"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1),{"name":"rating","hash":{},"data":data,"loc":{"start":{"line":15,"column":10},"end":{"line":15,"column":36}}}))
    + "\r\n          <div class=\"summary\">\r\n            <div class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_TEXT_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n          </div>\r\n        </a>\r\n      </div>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"OFFER_TERMS_LABEL") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":4},"end":{"line":29,"column":11}}})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"offer-terms offer-terms_under-headline\">\r\n        "
    + ((stack1 = (lookupProperty(helpers,"termsAndConditions")||(depth0 && lookupProperty(depth0,"termsAndConditions"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"termsAndConditionOffer") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),true,((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"OFFER_TERMS_LABEL") : stack1),{"name":"termsAndConditions","hash":{},"data":data,"loc":{"start":{"line":27,"column":8},"end":{"line":27,"column":125}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"show-for-small-only\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1)) != null ? lookupProperty(stack1,"toggle") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":6},"end":{"line":52,"column":18}}})) != null ? stack1 : "")
    + "    </div>\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <a id=\"ratings-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "-small\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_VALUE") : stack1), depth0))
    + "\" class=\"rating-link\"\r\n        target=\"_blank\" rel=\"noopener noreferrer\">\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"rating")||(depth0 && lookupProperty(depth0,"rating"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1),{"name":"rating","hash":{},"data":data,"loc":{"start":{"line":46,"column":8},"end":{"line":46,"column":34}}}))
    + "\r\n        <div class=\"summary\">\r\n          <div class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_TEXT_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </div>\r\n      </a>\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"callout\">\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image2") : stack1),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":61,"column":8},"end":{"line":61,"column":34}}}))
    + "\r\n        <p class=\"callout-copy\">\r\n          <span class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "</span>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_MB_SPECIAL_CALLOUT") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </p>\r\n      </div>\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"program-rules\">\r\n          "
    + container.escapeExpression((lookupProperty(helpers,"getProgramRulesLink")||(depth0 && lookupProperty(depth0,"getProgramRulesLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"programRulesPopup") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_LABEL") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_LINK") : stack1),{"name":"getProgramRulesLink","hash":{},"data":data,"loc":{"start":{"line":106,"column":10},"end":{"line":106,"column":122}}}))
    + "\r\n        </p>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row card-info\" data-campaign=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" data-group-code=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"GROUP_CODE") : stack1), depth0))
    + "\"\r\n  data-source-code=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"SOURCE_CODE") : stack1), depth0))
    + "\" data-product-name=\""
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"EPRODUCT_NAME") : stack1), depth0)) != null ? stack1 : "")
    + "\">\r\n  <div class=\"small-12 medium-3 large-2 column card-info-left\">\r\n    <a href=\""
    + container.escapeExpression((lookupProperty(helpers,"learnMoreUrl")||(depth0 && lookupProperty(depth0,"learnMoreUrl"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"learnMore") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),{"name":"learnMoreUrl","hash":{},"data":data,"loc":{"start":{"line":4,"column":13},"end":{"line":4,"column":65}}}))
    + "\" id=\"learn-more-image-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" class=\"learn\">\r\n      "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":6},"end":{"line":6,"column":37}}})) != null ? stack1 : "")
    + "\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image1") : stack1),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":7,"column":6},"end":{"line":7,"column":32}}}))
    + "\r\n      <span class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n    </a>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1)) != null ? lookupProperty(stack1,"toggle") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":2},"end":{"line":23,"column":14}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"OFFER_TERMS_ENABLE") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":2},"end":{"line":30,"column":14}}})) != null ? stack1 : "")
    + "  </div>\r\n  <div class=\"small-12 medium-9 large-10 column card-details\">\r\n    <h2 data-font=\"cnx-regular\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"learnMore")||(depth0 && lookupProperty(depth0,"learnMore"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"learnMoreTitle") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"learnMore") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"performanceMeta") : stack1),{"name":"learnMore","hash":{},"data":data,"loc":{"start":{"line":34,"column":6},"end":{"line":38,"column":34}}})) != null ? stack1 : "")
    + "\r\n    </h2>\r\n    <h3 class=\"sub-heading\" data-font=\"cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_MB_INCENTIVE_SHORT") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1)) != null ? lookupProperty(stack1,"value") : stack1),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":4},"end":{"line":54,"column":11}}})) != null ? stack1 : "")
    + "    <div class=\"benefits-and-callout-wrapper benefits-and-callout-wrapper--small-only\">\r\n      <p class=\"benefits\">\r\n        <span class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "</span>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_MB_AMF_SHORT") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </p>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"callout") : stack1)) != null ? lookupProperty(stack1,"toggle") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":59,"column":6},"end":{"line":66,"column":18}}})) != null ? stack1 : "")
    + "    </div>\r\n    <div class=\"benefits-and-callout-wrapper show-for-medium-up\">\r\n      <p class=\"benefits\">\r\n        <span class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "</span>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_MB_AMF_SHORT") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </p>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"callout") : stack1)) != null ? lookupProperty(stack1,"toggle") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":72,"column":6},"end":{"line":79,"column":18}}})) != null ? stack1 : "")
    + "    </div>\r\n    <div class=\"spa-squeezebox\">\r\n      <span class=\"spa-squeezebox-item\">\r\n        <div class=\"spa-squeezebox-heading\">\r\n          <button class=\"spa-squeezebox-heading spa-squeezebox-link spa-btn spa-btn--link\" href=\"#bullet-list-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" id=\"toggle-bullet-list-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" aria-expanded=\"true\">\r\n            <div class=\"show-for-small-up\">\r\n              <span class=\"show-more\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"showMoreCopy") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n              <span class=\"show-less\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"showLessCopy") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n            </div>\r\n            <div class=\"ada-hidden\"> "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n            <span class=\"spa-squeezebox-arrow spa-arrow-btn spa-arrow-btn--learn-more\"> </span>\r\n          </button>\r\n        </div>\r\n        <div id=\"bullet-list-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" class=\"spa-squeezebox-content bullet-list-content\">\r\n          <ul>\r\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_BULLET_LIST_RESEARCH") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n          </ul>\r\n        </div>\r\n      </span>\r\n    </div>\r\n    <div class=\"terms-and-rules\">\r\n      <p class=\"terms\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"termsAndConditions")||(depth0 && lookupProperty(depth0,"termsAndConditions"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"termsAndCondition") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),{"name":"termsAndConditions","hash":{},"data":data,"loc":{"start":{"line":102,"column":6},"end":{"line":102,"column":86}}})) != null ? stack1 : "")
    + "\r\n      </p>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_ENABLE") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":104,"column":6},"end":{"line":108,"column":18}}})) != null ? stack1 : "")
    + "    </div>\r\n    <div class=\"action-buttons\">\r\n      <div class=\"cta-action show-for-medium-up\">\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"learnMore")||(depth0 && lookupProperty(depth0,"learnMore"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"learnMoreMediumUp") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"learnMore") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"performanceMeta") : stack1),{"name":"learnMore","hash":{},"data":data,"loc":{"start":{"line":112,"column":8},"end":{"line":116,"column":35}}}))
    + "\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowMediumUp") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),null,((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"performanceMeta") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"USA_ENABLE") : stack1),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":117,"column":8},"end":{"line":125,"column":29}}}))
    + "\r\n      </div>\r\n      <div class=\"cta-action show-for-small-only\">\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"learnMore")||(depth0 && lookupProperty(depth0,"learnMore"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"learnMoreSmall") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"learnMore") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"performanceMeta") : stack1),{"name":"learnMore","hash":{},"data":data,"loc":{"start":{"line":128,"column":8},"end":{"line":132,"column":35}}}))
    + "\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowSmall") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),null,((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"performanceMeta") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"USA_ENABLE") : stack1),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":133,"column":8},"end":{"line":141,"column":29}}}))
    + "\r\n      </div>\r\n      <div class=\"add-to-compare show-for-medium-up\">\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"compareProduct")||(depth0 && lookupProperty(depth0,"compareProduct"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"compare") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"compareLabel") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"CARD_IMAGE_SMALL") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_POSITION") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_COLOR") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"EPRODUCT_NAME") : stack1),{"name":"compareProduct","hash":{},"data":data,"loc":{"start":{"line":144,"column":8},"end":{"line":145,"column":126}}}))
    + "\r\n      </div>\r\n    </div>\r\n    <div class=\"add-to-compare-for-small show-for-small-only\" id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\">\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"checkbox")||(depth0 && lookupProperty(depth0,"checkbox"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"addToCompareForSmall") : stack1),{"name":"checkbox","hash":{},"data":data,"loc":{"start":{"line":149,"column":6},"end":{"line":149,"column":47}}}))
    + "\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"barker")||(depth0 && lookupProperty(depth0,"barker"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_POSITION") : stack1),{"name":"barker","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":92}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <a id=\"ratings-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_VALUE") : stack1), depth0))
    + "\" class=\"rating-link show-for-medium-up\" target=\"_blank\" rel=\"noopener noreferrer\">\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"rating")||(depth0 && lookupProperty(depth0,"rating"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1),{"name":"rating","hash":{},"data":data,"loc":{"start":{"line":10,"column":6},"end":{"line":10,"column":32}}}))
    + "\r\n      <div class=\"summary\">\r\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_TEXT_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "<span class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"ratingsADAText") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n      </div>\r\n    </a>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <a id=\"ratings-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "-small\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_VALUE") : stack1), depth0))
    + "\" class=\"rating-link show-for-small-only\"\r\n      target=\"_blank\" rel=\"noopener noreferrer\">\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"rating")||(depth0 && lookupProperty(depth0,"rating"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1),{"name":"rating","hash":{},"data":data,"loc":{"start":{"line":26,"column":6},"end":{"line":26,"column":32}}}))
    + "\r\n      <div class=\"summary\">\r\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_TEXT_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </a>\r\n    ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row card-info market-card-info\" data-campaign=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" data-group-code=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"GROUP_CODE") : stack1), depth0))
    + "\" data-source-code=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"SOURCE_CODE") : stack1), depth0))
    + "\"\r\n  data-product-name=\""
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"EPRODUCT_NAME") : stack1), depth0)) != null ? stack1 : "")
    + "\">\r\n  <div class=\"small-12 medium-3 column card-info-left\">\r\n    <a id=\"learn-more-image-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "'\" class=\"learn\">\r\n      "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":6},"end":{"line":5,"column":99}}})) != null ? stack1 : "")
    + " "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image1") : stack1),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":5,"column":100},"end":{"line":5,"column":126}}}))
    + "\r\n      <span class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n    </a>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1)) != null ? lookupProperty(stack1,"toggle") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":15,"column":16}}})) != null ? stack1 : "")
    + "    <p class=\"benefits show-for-medium-up\" data-font=\"cnx-regular\">\r\n      "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_MB_AMF_SHORT") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </p>\r\n  </div>\r\n  <div class=\"small-12 medium-9 column\">\r\n    <h3 data-font=\"cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"learnMoreTitle") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n    <h4 class=\"sub-heading\" data-font=\"cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKET_EXPANSION_INCENTIVE") : stack1), depth0)) != null ? stack1 : "")
    + "</h4>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1)) != null ? lookupProperty(stack1,"toggle") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":4},"end":{"line":31,"column":16}}})) != null ? stack1 : "")
    + " \r\n    <ul class=\"spa-accordion show-for-small-only\">\r\n      <li class=\"spa-accordion-item\">\r\n        <h4 class=\"spa-accordion-heading\">\r\n          <a class=\"spa-accordion-link\" href=\"#rates-fees-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" id=\"toggle-rates-fees-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\">\r\n            <span class=\"spa-accordion-arrow spa-arrow-btn spa-arrow-btn--learn-more\"> </span>\r\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"LABEL_RATES_FEES") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n          </a>\r\n        </h4>\r\n        <div id=\"rates-fees-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" class=\"spa-accordion-content rates-fees-content\">\r\n          <h5>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"LABEL_INTRO_APR") : stack1), depth0)) != null ? stack1 : "")
    + "</h5>\r\n          <div class=\"rates-desc\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"INTEREST_RATES_FEES_INTRO_APR_SHORT") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          <h5>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"LABEL_STANDARD_APR") : stack1), depth0)) != null ? stack1 : "")
    + "</h5>\r\n          <div class=\"rates-desc\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"INTEREST_RATES_FEES_STANDARD_APR_RESEARCH") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          <h5>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"LABEL_ANNUAL_FEE") : stack1), depth0)) != null ? stack1 : "")
    + "</h5>\r\n          <div class=\"rates-desc\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"INTEREST_RATES_FEES_STANDARD_ANNUAL_FEE_RESEARCH") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          <h5>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"LABEL_BT_FEE") : stack1), depth0)) != null ? stack1 : "")
    + "</h5>\r\n          <div class=\"rates-desc\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"INTEREST_RATES_FEES_BT_FEE_RESEARCH") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          <div class=\"rates-fees\">\r\n            <sup aria-hidden='true'>&dagger; </sup>"
    + ((stack1 = (lookupProperty(helpers,"termsAndConditions")||(depth0 && lookupProperty(depth0,"termsAndConditions"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"completeRatesAndFees") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),{"name":"termsAndConditions","hash":{},"data":data,"loc":{"start":{"line":50,"column":51},"end":{"line":50,"column":134}}})) != null ? stack1 : "")
    + "</div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n    <ul class=\"show-for-medium-up\">\r\n      "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_BULLET_LIST_RESEARCH") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </ul>\r\n    <p class=\"terms show-for-medium-up\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"termsAndConditions")||(depth0 && lookupProperty(depth0,"termsAndConditions"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"termsAndCondition") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),{"name":"termsAndConditions","hash":{},"data":data,"loc":{"start":{"line":58,"column":6},"end":{"line":58,"column":86}}})) != null ? stack1 : "")
    + "\r\n    </p>\r\n    <div class=\"cta-action btn-and-phone show-for-medium-up\">\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowMediumUp") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),null,"",((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"USA_ENABLE") : stack1),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":61,"column":6},"end":{"line":61,"column":144}}}))
    + "\r\n      <div class=\"phone-code-info\">\r\n        <div class=\"contains-phone-number\">\r\n          "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"HELP_CENTER_PHONE_NUMBER") : stack1), depth0))
    + "\r\n        </div>\r\n        <div class=\"contains-phone-code\">\r\n          "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"priorityCodeLabel") : stack1), depth0))
    + ": "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"APPLICATION_DISPLAY_APPLY_BY_PHONE_SOURCE_CODE") : stack1), depth0))
    + "\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"cta-action btn-and-phone show-for-small-only\">\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowSmall") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),null,"",((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"USA_ENABLE") : stack1),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":72,"column":6},"end":{"line":72,"column":142}}}))
    + "\r\n      <div class=\"phone-code-info\">\r\n        <div class=\"contains-phone-number\">\r\n          "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"HELP_CENTER_PHONE_NUMBER") : stack1), depth0))
    + "\r\n        </div>\r\n        <div class=\"contains-phone-code\">\r\n          "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"priorityCodeLabel") : stack1), depth0))
    + ": "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"APPLICATION_DISPLAY_APPLY_BY_PHONE_SOURCE_CODE") : stack1), depth0))
    + "\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/card-list-cc-module",
  "version": "5.0.9",
  "id": "cardListCcModule",
  "containerID": "creditCardsCardListCcModule",
  "moduleName": "credit-cards-card-list-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "card-list-cc-module",
  "data": {
    "init": "cardListCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "filter",
    "type": "object",
    "default": {},
    "description": "Filter for the cards to be displayed. See README.md"
  }, {
    "name": "id",
    "type": "string",
    "values": ["popularCards"],
    "default": "popularCards",
    "description": "predefined IDs"
  }, {
    "name": "isMarketExpansionPage",
    "values": [true, false],
    "default": false,
    "description": "Standard or Market Expansion card list"
  }, {
    "name": "prodCategoryId",
    "type": "string",
    "default": "cards:DA",
    "description": "Coremetrics product category id."
  }, {
    "name": "requestParams",
    "type": "object",
    "default": {},
    "description": "Query string parameters to the service."
  }, {
    "name": "requesttype",
    "values": ["C", "BCC"],
    "default": "C",
    "description": "Consumer or Small Business Request Type"
  }, {
    "name": "useaccordion",
    "values": [true, false],
    "default": false,
    "description": "Consumer or Small Business Request Type"
  }, {
    "name": "cardListExpandAll",
    "values": [true, false],
    "default": true,
    "description": "Expands all content under show more"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$2(context, {
      "helpers": {
        checkbox,
        compare,
        picture,
        json,
        learnMore,
        learnMoreUrl,
        barker,
        termsAndConditions,
        applyNow,
        compareProduct,
        rating,
        getProgramRulesLink
      },
      "partials": {
        "card-info": renderTemplate$1,
        "market-area-card-info": renderTemplate
      }
    });
  },
  "template": renderTemplate$2,
  "partials": {
    "card-info": renderTemplate$1,
    "market-area-card-info": renderTemplate
  },
  "helpers": {
    checkbox,
    compare,
    picture,
    json,
    learnMore,
    learnMoreUrl,
    barker,
    termsAndConditions,
    applyNow,
    compareProduct,
    rating,
    getProgramRulesLink
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/squeezebox-helper": "^1.0.0",
    "@sparta.global.helpers/checkbox-helper": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.global.utilities/sparta-global-functions-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-global-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-lazy-load-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* eslint-disable no-console */
/* global spaParams sparta */
/* eslint-disable no-param-reassign */

let hasModuleInit = false;

/**
 * @export
 * @class cardListCcModuleJS
 * @extends {Module}
 */
class cardListCcModuleJS extends Module {
  /**
   * constructor
   * @param {*} options - options object
   * @param {*} context - context object
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.templateCardInfo = _moduleConfig.partials['card-info'];
    this.marketAreaTemplate = _moduleConfig.partials['market-area-card-info'];
    this.addRemoveCardAnnouncementEl = target.querySelector('.compare-card-add-remove-announcement');
    try {
      this.cardList = JSON.parse(target.querySelector('.card-list').dataset.jcr);
      this.cardContent = JSON.parse(target.querySelector('.card-content').dataset.jcr);
      if (this.params.isMarketExpansionPage) {
        this.marketArea = spartaGlobalFunctions.getUrlParam('area');
        this.cardList = this.marketArea ? this.cardList[this.marketArea] : [];
      } else {
        this.cardList = Object.values(this.cardList);
      }
    } catch (err) {
      console.error(err);
    }
    this.campaignData = {};
  }

  /**
   * init
   * @returns {void}
   */
  init() {
    if (!hasModuleInit) {
      hasModuleInit = true;
      this.renderList();
      this.bindEventListeners();
      this.bindEvents();
    }
  }

  /**
   * renderList
   * @returns {void}
   */
  renderList() {
    const campaigns = [];
    const properties = this.cardContent.campaignProperties;
    if (this.cardList) {
      this.cardList.forEach(card => {
        if (card.campaign) {
          const campaignId = card.campaign.split('~').splice(0, 2).join('~');
          campaigns.push(campaignId);
        }
      });
    }
    creditCardUtility.productPropertiesMap(this.params.requestParams, campaigns, properties).then(result => {
      this.campaignData = result;
      let cardsHtml = '';
      Object.keys(result).forEach(campaignId => {
        const data = result[campaignId];
        const campaign = Object.assign(data, {
          ID: campaignId,
          BYAPAGE_ENABLE: data.BYAPAGE_ENABLE && data.BYAPAGE_ENABLE.toLowerCase() === 'yes',
          rating: {
            toggle: data.PRODUCT_REVIEW_RATING_ENABLE,
            value: data.PRODUCT_REVIEW_RATING,
            URL: data.PRODUCT_REVIEW_RATING_VALUE
          },
          callout: {
            toggle: data.PRODUCT_MB_SPECIAL_CALLOUT !== undefined ? 'YES' : false,
            value: data.PRODUCT_MB_SPECIAL_CALLOUT,
            image: data.PRODUCT_MB_SPECIAL_CALLOUT_IMAGE
          }
        });
        this.adaDaggerFix(campaign);
        const content = this.generateCardContent(campaign);
        const cardInfo = this.cardList.filter(card => card.campaign === campaignId)[0] || {};
        let renderedTemplate;
        if (this.params.isMarketExpansionPage) {
          renderedTemplate = this.marketAreaTemplate({
            content,
            campaign,
            params: this.params,
            site: spaParams.siteParams,
            sparta,
            cardInfo
          });
        } else {
          renderedTemplate = this.templateCardInfo({
            content,
            campaign,
            params: this.params,
            site: spaParams.siteParams,
            sparta,
            cardInfo
          });
        }

        // Populate any offer terms links
        renderedTemplate = this.getRenderedTemplateWithPopulatedPcmLinks(this.cardContent, campaign, cardInfo, renderedTemplate);
        cardsHtml += renderedTemplate;
      });
      const cardsListEl = this.settings.target.querySelector('.cards-list-placeholder');
      cardsListEl.innerHTML = cardsHtml;
      if (this.params.isMarketExpansionPage) {
        Array.from(cardsListEl.querySelectorAll('a.calc-link')).forEach(link => {
          // Remove calculator links that come from PCM
          link.style.display = 'none';
        });
      }

      // Only run filter on render if we have any
      if (Object.keys(this.params.filter).length) {
        this.filterCardsUi(this.params.filter);
      }
      this.Events.pub(creditCardUtility.EVENTS.cardListReady, {
        id: this.settings.target.id
      });
      this.Events.sub(creditCardUtility.EVENTS.compareData, this.handleCompareData.bind(this), true);
      spartaLazyLoadUtility.init();
    }).catch(error => {
      this.Events.pub(creditCardUtility.EVENTS.errorShowHome, {});
      console.error(error); // eventually use the core debug utility for this
      spartaLazyLoadUtility.init(); // lazy load images that are not coming from PCM
    });
  }

  /**
   * Hack to add ada attributes to dagger superscripts from PCM
   * They refuse to change it on the backend, so we're
   * forced to make this swap on the frontend.
   *
   * @param {*} campaign - campaign object to replace values within.
   * @memberof campaignPropertiesCcModuleJS
   * @returns {void}
   */
  adaDaggerFix(campaign) {
    Object.keys(campaign).forEach(key => {
      if (typeof campaign[key] === 'string') {
        campaign[key] = campaign[key].replace(/fee†/g, 'fee<sup aria-hidden=\'true\'>†</sup>');
        campaign[key] = campaign[key].replace(/<sup>&dagger;<\/sup>/g, '<sup aria-hidden="true">&dagger;</sup>');
        campaign[key] = campaign[key].replace(/<sup>†<\/sup>/g, '<sup aria-hidden="true">†</sup>');
        campaign[key] = campaign[key].replace(/<sup>† <\/sup>/g, '<sup aria-hidden=\'true\'>† </sup>');
        campaign[key] = campaign[key].replace(/<sup><span style="font-size: small;">†<\/span><\/sup>/g, '<sup aria-hidden="true"><span style="font-size: small;">†</span></sup>');
      }
    });
  }

  /**
   * generateCardContent
   *
   * @description Swaps out the tokens from JCR cardContent since the links are used dynamically.
   * @param {*} campaign - campaign containing product data
   * @returns {void}
   */
  generateCardContent(campaign) {
    // Expose site params to use in jcr such as site.siteRoot
    const data = {
      site: spaParams.siteParams,
      ...campaign
    };
    const cardContentString = JSON.stringify(this.cardContent);
    const generated = JSON.parse(Handlebars.compile(cardContentString)(data));
    return generated;
  }

  /**
   * filterCardsUi
   *
   * @description Show and hide different cards on the page based on filters.
   * The page filters are set in the module params and multiple can be applied:
   * "filter": {
   *   "type": "masterCard", // "visa"
   *   "features": ["preferredRewards"],
   *   "ratesFees": ["noAnnualFee", "noForeignTransactionFee",
   *     "zeroAprBalance", "zeroAprPurchase"],
   *   "category": ["cash", "lowInterest", "buildCredit", "points", "students", "travel"]
   * }
   * @see README.md
   * @param {Object} filter Could be a Filter obj but didn't want to overengineer it. Example above.
   * @returns {void}
   */
  filterCardsUi(filter) {
    let count = 0;
    if (this.cardList) {
      this.cardList.forEach(cardList => {
        if (cardList.campaign) {
          const cardEl = this.settings.target.querySelector(`[data-campaign="${cardList.campaign}"]`);
          if (cardEl) {
            cardEl.classList.remove('visible');
            this.setShowHideDetails(cardEl, cardList);

            // Filter made human readable
            const hasType = this.hasType(filter.type, cardList.type, true);
            const hasCategory = this.hasCategory(filter.category, cardList.category, true, false);
            const hasFeature = this.hasFeature(filter.features, cardList.features, true, true);
            const hasRatesFees = this.hasRatesFees(filter.ratesFees, cardList.ratesFees, true, false);
            if (hasType && hasCategory && hasFeature && hasRatesFees) {
              cardEl.classList.add('visible');
              cardEl.classList.remove('hidden');
              cardEl.setAttribute('aria-hidden', false);
              this.bactmAdd(cardEl);
              count += 1;
            } else {
              cardEl.classList.add('hidden');
              cardEl.setAttribute('aria-hidden', true);
            }
          }
        }
      });
      const firstVisibleCardEl = this.settings.target.querySelector('[data-campaign].visible');
      creditCardUtility.prefetchCard(firstVisibleCardEl);
    }

    /* eslint-disable */
    if (typeof bactm_productView !== 'undefined') {
      // coremetrics: execute ProductView tag
      bactm_productView();
    }
    /* eslint-enable */

    // Publish the count
    this.Events.pub(creditCardUtility.EVENTS.cardListCount, {
      id: this.settings.target.id,
      count
    });

    // Always recalc sticky due to dom changes
    spartaStickyUtility.recalcStickyEls();
  }

  /**
   * setShowHideDetails
   *
   * @description Initialize and transform the show hide details that PCM provides.
   * The old way use to do a document element lookup and use the campaign attribute.
   * Can save CPU cycles by not repeating another loop and lookup.
   * @param {Object} cardEl - card element on page
   * @param {Object} cardInfo - card data
   * @returns {void}
   */
  setShowHideDetails(cardEl, cardInfo) {
    // eslint-disable-line
    const campaignId = cardInfo.campaign;
    const showAndHideDetails = cardEl.querySelectorAll('.showDetails, .hideDetails');
    Array.from(showAndHideDetails).forEach((showAndHideDetail, i) => {
      const showType = showAndHideDetail.classList.contains('showDetails') ? 'show' : 'hide';

      // Generate anchor link to replace span with
      const anchor = document.createElement('a');
      anchor.innerHTML = showAndHideDetail.innerHTML;
      anchor.className = showAndHideDetail.className;
      anchor.tabIndex = 0;
      anchor.href = 'javascript:void(0);'; // eslint-disable-line
      anchor.id = `${showType}-details-${campaignId}-${i}`;
      if (showType === 'hide') {
        anchor.dataset.toggleId = `show-details-${campaignId}-${i - 1}`;
      }
      showAndHideDetail.parentNode.replaceChild(anchor, showAndHideDetail);
    });
  }

  /**
   * hasType
   *
   * @description Checks if the card has the type in the filter
   * @param {String} filterType -
   * @param {Object} cardType -
   * @param {Bool} defaultReturn -
   * @returns {Bool} has type
   */
  hasType(filterType, cardType, defaultReturn = true) {
    // eslint-disable-line
    let hasType = defaultReturn;
    if (filterType) {
      hasType = false;
    }
    if (filterType === cardType) {
      hasType = true;
    }
    return hasType;
  }

  /**
   * hasCategory
   *
   * @description Checks if the card has the category in the filter
   * @param {Object} filterCategory -
   * @param {Object} cardCategory -
   * @param {Bool} defaultReturn -
   * @param {Bool} greedy -
   * @returns {Bool} has category
   */
  hasCategory(filterCategory, cardCategory, defaultReturn = true, greedy = true) {
    // eslint-disable-line
    let hasCategory = defaultReturn;
    if (filterCategory) {
      hasCategory = false;
      const filteredCategory = filterCategory.filter(category => cardCategory.indexOf(category) >= 0); // eslint-disable-line

      if (greedy) {
        hasCategory = filteredCategory.length > 0;
      } else {
        hasCategory = filteredCategory.length === filterCategory.length;
      }
    }

    // Prevent featured cards showing on category pages, these are for overview only
    if (this.params.filter && Object.keys(this.params.filter).length && cardCategory.indexOf('featured') > -1 && cardCategory.length === 1) {
      return false;
    }
    return hasCategory;
  }

  /**
   * hasFeature
   *
   * @description Checks if the card has the features in the filter
   * @param {Object} filterFeatures -
   * @param {Object} cardFeatures -
   * @param {Bool} defaultReturn -
   * @param {Bool} greedy -
   * @returns {Bool} has feature
   */
  hasFeature(filterFeatures, cardFeatures, defaultReturn = true, greedy = true) {
    // eslint-disable-line
    let hasFeature = defaultReturn;
    if (filterFeatures) {
      hasFeature = false;
      const filtered = filterFeatures.filter(feature => cardFeatures.indexOf(feature) >= 0);
      if (greedy) {
        hasFeature = filtered.length > 0;
      } else {
        hasFeature = filtered.length === filterFeatures.length;
      }
    }
    return hasFeature;
  }

  /**
   * hasRatesFees
   *
   * @description Checks if the card has the rates fees in the filter
   * @param {Object} filterRatesFees -
   * @param {Object} cardRatesFees -
   * @param {Bool} defaultReturn -
   * @param {Bool} greedy -
   * @returns {Bool} has rates fees
   */
  hasRatesFees(filterRatesFees, cardRatesFees, defaultReturn = true, greedy = true) {
    // eslint-disable-line
    let hasRatesFees = defaultReturn;
    if (filterRatesFees) {
      hasRatesFees = false;
      const filteredFeatures = filterRatesFees.filter(feature => cardRatesFees.indexOf(feature) >= 0); // eslint-disable-line

      if (greedy) {
        hasRatesFees = filteredFeatures.length > 0;
      } else {
        hasRatesFees = filteredFeatures.length === filterRatesFees.length;
      }
    }
    return hasRatesFees;
  }

  /**
   * bindEvents
   * @returns {void}
   */
  bindEvents() {
    this.Events.sub(creditCardUtility.EVENTS.cardListFilter, this.handleCardListFilter.bind(this), true);
    this.Events.sub(creditCardUtility.EVENTS.cardListReady, this.handleCompareForSmall.bind(this), true);
    this.Events.sub(creditCardUtility.EVENTS.cardListReady, this.handleExpandAll.bind(this), true);
  }

  /**
   * handleCardListFilter
   *
   * @param {Object} res Published response
   * @returns {void}
   */
  handleCardListFilter(res) {
    const {
      data
    } = res;
    if (data.id && this.settings.target.id === data.id) {
      this.filterCardsUi(data.filter);
    }
  }

  /**
   * bindEventListeners
   *
   * @description Binds the event listeners for the module
   * @returns {void}
   */
  bindEventListeners() {
    const {
      target
    } = this.settings;
    creditCardUtility.delegateEvent('click', '.spa-boa-program-rules-window', this.handlePopupLink.bind(this), false, target);
    creditCardUtility.delegateEvent('click', '.apply', this.handleApplyLink.bind(this), false, target);
    creditCardUtility.delegateEvent('click', '.showDetails', this.handleShowDetails.bind(this), false, target);
    creditCardUtility.delegateEvent('click', '.hideDetails', this.handleHideDetails.bind(this), false, target);
    creditCardUtility.delegateEvent('click', '.spa-squeezebox-link', this.handleToggleAccordion.bind(this), false, target);
    creditCardUtility.delegateEvent('click', '.spa-boa-tnc-window', this.handleTermsLink.bind(this), false, target);
    creditCardUtility.delegateEvent('change', '.compare-selector input', this.handleCompareAdd.bind(this), false, target);

    // cannot use delegateEvent
    // because this element's parent (.spa-squeezebox-link)
    // will reverse the action by toggling again
    const allArrows = this.settings.target.querySelectorAll('.spa-squeezebox-arrow');
    if (allArrows) {
      [...allArrows].forEach(arrow => {
        arrow.addEventListener('click', this.handleToggleAccordion.bind(this));
      });
    }
  }

  /**
   * handleApplyLink
   *
   * @param {HTMLEvent} event - mouseevent clicking on the apply button
   *
   * @description Handles the apply link events
   * @returns {void}
   */
  handleApplyLink(event) {
    const isNewTabKeyHeld = event.ctrlKey || event.shiftKey || event.metaKey;
    const notMda = !document.documentElement.classList.contains('mda');
    if (notMda && !isNewTabKeyHeld && !event.target.hasAttribute('data-zip-code-gating')) {
      this.Events.pub(creditCardUtility.EVENTS.loaderShow, {});
    }
  }

  /**
   * handleShowDetails
   *
   * @description Sets the active class on the show, css sibling selector will show the details
   * @param {Event} e - click event
   * @returns {void}
   */
  handleShowDetails(e) {
    // eslint-disable-line
    e.preventDefault();
    e.target.classList.toggle('active');
  }

  /**
   * handleHideDetails
   *
   * @description Toggles the show cta active class from the data attribute we set for toggle id
   * @param {Event} e - click event
   * @returns {void}
  */
  handleHideDetails(e) {
    // eslint-disable-line
    e.preventDefault();
    const {
      toggleId
    } = e.target.dataset;
    document.getElementById(toggleId).classList.toggle('active');
  }

  /**
   * handleToggleAccordion
   *
   * @description Toggles the accordion that is used for small viewport
   * @param {Event} e - click event
   * @returns {void}
   */
  handleToggleAccordion(e) {
    // eslint-disable-line
    e.preventDefault();
    const showMoreLessBtn = e.target.closest('.spa-squeezebox-item');
    showMoreLessBtn?.classList.toggle('active');
    const squeezeboxLinkBtn = showMoreLessBtn?.querySelector('.spa-squeezebox-heading.spa-squeezebox-link');
    // get the closest button to add exapnded or collapsed attribues
    squeezeboxLinkBtn?.setAttribute('aria-expanded', showMoreLessBtn?.classList.contains('active'));
    // to rotate the arrow icon based on exand or collapse
    squeezeboxLinkBtn?.querySelector('.spa-squeezebox-arrow')?.classList.toggle('active');
  }

  /**
   * handleTermsLink
   *
   * @param {Event} e - click event
   * @returns {void}
   */
  handleTermsLink(e) {
    e.preventDefault();
    spartaUILayersUtility.displayPopup(e.target.href, 'termsAndConditions', 'left=50,top=50,width=1100,height=750,scrollbars,status=1,resizable=1');
  }

  /**
   * handleCompareAdd
   *
   * @param {Event} e - click event
   * @returns {void}
   */
  handleCompareAdd(e) {
    const {
      dataset,
      checked
    } = e.target;
    this.addRemoveCardAnnouncementEl.innerHTML = `${dataset.product} ${checked ? 'added compare credit card dialogue has appeared and is available for review' : 'removed'}`;
    this.Events.pub(creditCardUtility.EVENTS.compareUpdate, {
      ...dataset
    });
  }

  /**
   * handleCompareData
   *
   * @param {Object} res - response
   * @returns {void}
   */
  handleCompareData(res) {
    const {
      target
    } = this.settings;
    const {
      data
    } = res;
    const {
      campaigns
    } = data;
    if (!campaigns) {
      return;
    }
    this.resetActiveCompare();
    campaigns.forEach(campaign => {
      const inputEls = [...target.querySelectorAll(`input[data-campaign="${campaign.campaign}"]`)];
      if (!inputEls.length) {
        return;
      }
      inputEls.forEach(inputEl => {
        const parentId = inputEl.dataset.parent;
        // eslint-disable-next-line
        inputEl.checked = true;
        const cardEl = target.querySelector(`[data-campaign="${parentId}"]`);
        if (!cardEl) {
          return;
        }
        cardEl.classList.add('compare');
        const inputElForSmall = target.querySelector(`input[data-id="addToCompareForSmall${parentId}"]`);
        if (inputElForSmall) {
          inputElForSmall.checked = true;
        }
      });
    });
  }

  /**
   * resetActiveCompare
   * @returns {void}
   */
  resetActiveCompare() {
    const cards = this.settings.target.querySelectorAll('.card-info');
    Array.from(cards).forEach(card => {
      card.classList.remove('compare');
      const inputs = card.querySelectorAll('input[type=checkbox]');
      Array.from(inputs).forEach(input => {
        // eslint-disable-next-line no-param-reassign
        input.checked = false;
      });
    });
  }

  /**
   * bactmAdd
   *
   * @description Add products to coremetrics
   * @param {Element} cardInfoEl -
   * @returns {void}
   */
  bactmAdd(cardInfoEl) {
    const data = cardInfoEl.dataset;

    /* eslint-disable */
    if (typeof bactm_addProducts !== 'undefined' && !data.cmProductAdded) {
      const productId = `${data.groupCode} ${data.sourceCode}`.trim();
      const {
        productName
      } = data;
      bactm_addProducts(productId, productName, this.params.prodCategoryId);
      data.cmProductAdded = true;
    }
    /* eslint-enable */
  }

  /**
   * handleCompareForSmall
   *
   * @description Adds a unique id for checkboxes and their respective labels
   * @returns {void}
   */
  handleCompareForSmall() {
    const {
      target
    } = this.settings;
    const compareContainer = target.querySelectorAll('.add-to-compare-for-small');
    if (compareContainer) {
      Array.from(compareContainer).forEach(container => {
        const checkboxWrapper = container.querySelector('.spa-input-options-wrapper');
        if (checkboxWrapper) {
          const inputLabel = checkboxWrapper.querySelector('.spa-input-option-label');
          if (inputLabel) {
            // tying the small view label to the original checkbox that shows on medium up
            inputLabel.htmlFor = `compare-${container.id}`;
          }
          const compareCheckbox = document.getElementById(`compare-${container.id}`);
          if (compareCheckbox) {
            const inputEl = checkboxWrapper.querySelector('#addToCompareForSmallEl');
            if (inputEl) {
              inputEl.id = `addToCompareForSmall${container.id}`;
              inputEl.dataset.id = `addToCompareForSmall${container.id}`;
              inputEl.addEventListener('change', () => {
                inputLabel.click();
              });
            }
          }
        }
      });
    }
  }

  /**
   * handleExpandAll
   *
   * @description Checks cardListExpandAll module param
   * and if true it expands all text under Show More
   *
   * @returns {void}
   */
  handleExpandAll() {
    if (this.params.cardListExpandAll) {
      const allCardsDetails = this.settings.target.querySelectorAll('.spa-squeezebox-item');
      if (allCardsDetails.length > 0) {
        [...allCardsDetails].forEach(details => {
          details.classList.add('active');
        });
        const allArrows = this.settings.target.querySelectorAll('.spa-squeezebox-arrow');
        [...allArrows].forEach(arrow => {
          arrow.classList.add('active');
        });
      }
    }
  }

  /**
   * handlePopupLink
   *
   * @param {Event} e - click event
   * @returns {void}
   */
  handlePopupLink(e) {
    e.preventDefault();
    const {
      href,
      id
    } = e.target;
    spartaUILayersUtility.displayPopup(href, id, 'left=50,top=50,width=1100,height=750,scrollbars,status=1,resizable=1');
  }

  /**
   * @description Any offer terms links sent from PCM need to be updated
   * with the same href and class generated by the termsAndConditions helper.
   * @param {Object} content content
   * @param {Object} campaign campaign
   * @param {Object} cardInfo campaign properties
   * @param {String} renderedTemplate renderedTemplate
   * @returns {String} rendered template with populated offer terms links
   */
  getRenderedTemplateWithPopulatedPcmLinks(content, campaign, cardInfo, renderedTemplate) {
    // Parse renderedTemplate
    const tempRenderedTemplateEl = document.createElement('div');
    tempRenderedTemplateEl.innerHTML = renderedTemplate;
    const pcmOfferTermsLinks = tempRenderedTemplateEl.querySelectorAll("[href='#creditCardTnCAnchor']");

    // Check for offer terms links
    if (pcmOfferTermsLinks && pcmOfferTermsLinks.length > 0) {
      // Create Offer Terms TnC pop-up link string.
      const anchorString = termsAndConditions(content.LINKS.termsAndConditionOffer, cardInfo.campaign, spaParams.siteParams, sparta, true, 'See Offer Terms' // Temporary string that will not be used ( we just need the href )
      );

      // Parse string for URL and programmatically obtain the href.
      const tempDivEl = document.createElement('div');
      tempDivEl.innerHTML = anchorString;
      const parsedAnchorTag = new URL(tempDivEl.firstChild);

      // Populate any links sent from PCM with the href and associated class
      pcmOfferTermsLinks.forEach(pcmLink => {
        // eslint-disable-next-line no-param-reassign
        pcmLink.href = parsedAnchorTag.href;
        pcmLink.classList.add('spa-boa-tnc-window');
      });
      return tempRenderedTemplateEl.innerHTML;
    }
    return renderedTemplate;
  }
}
registerModuleClass({
  moduleClass: cardListCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { cardListCcModuleJS as default, moduleConfig };
